import { Outlet } from 'react-router-dom';
import { TopNavigation } from '@/app/layout/TopNavigation.jsx';

// docs' screens: the install's top bar (logo, the install's modules, search,
// E-IMZO, the person menu) over the page. One install, one person signed in:
// no project sidebar. Framed by the client portal the bar is the portal's.
export const Layout = () => (
  // h-dvh (not h-screen): tracks the visible viewport under mobile browser chrome.
  <div className="flex flex-col h-dvh overflow-auto bg-background">
    {/* z-40: the bar's own popovers (the modules, the person menu) open over
        the page's raised parts (toolbars, callouts, z-30 at most), and under
        the dialogs and menus that portal to <body> (z-50). */}
    <div className="w-full sticky top-0 z-40">
      <TopNavigation />
    </div>
    <div className="flex-1 bg-background min-h-0">
      <Outlet />
    </div>
  </div>
);
